import { render, staticRenderFns } from "./MainCourseTableActions.vue?vue&type=template&id=510ebaa0&"
import script from "./MainCourseTableActions.vue?vue&type=script&lang=js&"
export * from "./MainCourseTableActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports